import { useEffect, useState } from 'react';

/**
 * Обратный отсчёт до заданного момента времени.
 *
 * Считает от абсолютной отметки (`deadline`), а не уменьшает счётчик на единицу
 * в интервале: вкладка в фоне тормозит таймеры, и счётчик «сколько осталось»
 * разошёлся бы с реальностью. Здесь расхождения не возникает — каждый тик
 * пересчитывает разницу заново.
 *
 * @param deadline момент окончания или `null`, если отсчёт не нужен
 * @returns целое число оставшихся секунд, не меньше нуля
 */
export function useCountdown(deadline: Date | null): number {
  const target = deadline?.getTime() ?? null;

  const [remaining, setRemaining] = useState(() => secondsLeft(target));

  useEffect(() => {
    if (target === null) {
      setRemaining(0);
      return;
    }

    setRemaining(secondsLeft(target));
    if (secondsLeft(target) === 0) return;

    const timer = window.setInterval(() => {
      const left = secondsLeft(target);
      setRemaining(left);
      if (left === 0) window.clearInterval(timer);
    }, 1000);

    return () => {
      window.clearInterval(timer);
    };
  }, [target]);

  return remaining;
}

function secondsLeft(target: number | null): number {
  if (target === null) return 0;
  return Math.max(0, Math.ceil((target - Date.now()) / 1000));
}

/** `95` -> `1:35`. Для таймеров повторной отправки и срока действия кода. */
export function formatDuration(totalSeconds: number): string {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
